import { Blog } from "@types"
import { Bell, Check } from "lucide-react"
import SubscribeButtonInlineClickHandler from "./SubscribeButtonInlineClickHandler"

export function SubscribeButtonInline({
  blog,
  isUserSubscribed,
  isUserLoggedIn,
  referrer,
  onSubscribeCallback,

  delay,
}: {
  blog: Pick<Blog, "id" | "lowercase_url">
  isUserSubscribed: boolean
  isUserLoggedIn: boolean
  referrer?: Blog
  onSubscribeCallback?: (blogId: string) => void
  delay?: number
}) {
  return (
    <SubscribeButtonInlineClickHandler
      blog={blog}
      referrer={referrer}
      onSubscribeCallback={onSubscribeCallback}
      isUserLoggedIn={isUserLoggedIn}
      delay={delay}
    >
      {isUserSubscribed ? <Check size={20} /> : <Bell size={20} />}
    </SubscribeButtonInlineClickHandler>
  )
}
